import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ToastContainer, toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const FetchDegree = ({ getDegrees }) => {
  const [showFetchDegreeModal, setShowFetchDegreeModal] = useState(false);
  const [fetchProgramName, setFetchProgramName] = useState("");
  const [fetchDescription, setFetchDescription] = useState("");
  const [fetchDepartment, setFetchDepartment] = useState("");
  const [fetchDegreeLevel, setFetchDegreeLevel] = useState("");
  const [fetchCampus, setFetchCampus] = useState("");
  const [fetchDuration, setFetchDuration] = useState("");
  const [fetchDurationType, setFetchDurationType] = useState("");
  const [fecthProgramShortCode, setFetchProgramShortCode] = useState("");
  const [fetchCreditHours, setFetchCreditHours] = useState("");
  const [apiLink, setApiLink] = useState("");
  const [mainVariable, setMainVariable] = useState("");
  const [auth, setAuth] = useState("no-auth");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [bearerToken, setBearerToken] = useState("");

  const handlefetchdegreeModal = () => {
    setShowFetchDegreeModal(true);
  };

  const handleCancelFetchDegreeModal = () => {
    setShowFetchDegreeModal(false);
  };

  const handleOkFetchDegreeModal = () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (auth === "basic-auth") {
      requestOptions.headers["Authorization"] = `Basic ${btoa(`${userName}:${password}`)}`;
    } else if (auth === "token-auth") {
      requestOptions.headers["Authorization"] = `Bearer ${bearerToken}`;
    }
    
    fetch(`${apiLink}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if(mainVariable===""){
          addDegrees(data);
        }
        else{
          addDegrees(data[mainVariable]);
        }
      })
      .catch((error) => console.log(error));
    setShowFetchDegreeModal(false);
  };

  const addDegrees = (degrees) => {
    const mappedDegrees = degrees.map((degree) => {
      return {
        program_name: getNestedProperty(degree, fetchProgramName),
        description: getNestedProperty(degree, fetchDescription),
        department: getNestedProperty(degree, fetchDepartment),
        degree_level: getNestedProperty(degree, fetchDegreeLevel),
        campus: getNestedProperty(degree, fetchCampus),
        duration: getNestedProperty(degree, fetchDuration),
        duration_type: getNestedProperty(degree, fetchDurationType),
        program_short_code: getNestedProperty(degree, fecthProgramShortCode),
        credit_hours: getNestedProperty(degree, fetchCreditHours),
      };
    });
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${token}`
      },
      body: JSON.stringify({ degrees: mappedDegrees }),
    };
    fetch(`${BASE_URL}/api/degree/add_degrees`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        toast.success("Degrees Fetched Successfully");
      })
      .catch((error) => console.log(error));
  };

  const getNestedProperty = (obj, path) => {
    const parts = path.split(".");
    let value = obj;
    for (let part of parts) {
      if (part.includes("[")) {
        const index = part.match(/\[(.*?)\]/)[1];
        value = value[part.split("[")[0]][index];
      } else {
        value = value[part];
      }
    }
    return value;
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<CloudUploadIcon />}
        onClick={handlefetchdegreeModal}
        style={{
          color: "#414149",
          borderColor: "#414149",
          fontWeight: "bold",
        }}
      >
        Fetch Degrees
      </Button>
      <Dialog
        open={showFetchDegreeModal}
        onClose={handleCancelFetchDegreeModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Fetch Degrees"}
        </DialogTitle>
        <DialogContent>
        <div className="row">
            <div className="col-md-12">
              <h6 className="text-danger">Note: Api Should have GET route</h6>
            </div>
            <div className="col-md-4 mt-2">
              <h6>1. program_name</h6>
            </div>
            <div className="col-md-8">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchProgramName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h6>2. description</h6>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchDescription(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h6>3. department</h6>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchDepartment(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h6>4. degree_level</h6>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchDegreeLevel(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h6>5. campus</h6>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchCampus(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h6>6. duration</h6>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchDuration(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h6>7. duration_type</h6>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchDurationType(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h6>8. program_short_code</h6>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchProgramShortCode(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h6>9. credit_hours</h6>
            </div>
            <div className="col-md-8 mt-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Field Name"
                onChange={(e) => setFetchCreditHours(e.target.value)}
              />
            </div>
            <div className="col-md-4 mt-3">
              <h5>Auth</h5>
            </div>
            <div className="col-md-8 mt-2">
              <select
                className="form-control"
                onChange={(e) => setAuth(e.target.value)}
                value={auth}
              >
                <option value="no-auth">No Auth</option>
                <option value="basic-auth">Basic Auth</option>
                <option value="token-auth">Bearer Token Auth</option>
              </select>
            </div>
            {auth === "basic-auth" && (
              <>
                <div className="col-md-6 mt-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Username"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
                <div className="col-md-6 mt-3">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter Your Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </>
            )}
            {auth === "token-auth" && (
              <div className="col-md-12 mt-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Token"
                  value={bearerToken}
                  onChange={(e) => setBearerToken(e.target.value)}
                />
              </div>
            )}
            <div className="col-md-12 mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Rest Api Link"
                onChange={(e) => setApiLink(e.target.value)}
              />
            </div>
            <div className="col-md-12 mt-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Your Main Variable Name"
                onChange={(e) => setMainVariable(e.target.value)}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelFetchDegreeModal}>
            Cancel
          </Button>
          <Button onClick={handleOkFetchDegreeModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FetchDegree;
